<template>
    <div class="assessors-page table-view">
        <div class="page-header">
            <h4>View Assessors</h4>
            <ol class="breadcrumbs">
                <li class="breadcrumb-item home">
                    <router-link to="/">Home</router-link>
                </li>
                <li class="breadcrumb-item active">View Assessors</li>
            </ol>
            <h4 class="header-display-name">{{ getterBusinessName }}</h4>
            <div class="page-header-nav-btn">
                <button v-if="!isCustomerUser && isStatusActive" @click="addNewAssessorRow" class="btn btn-primary w-min-sm waves-effect waves-light"><i
                        class="ti-plus"></i>New Assessor
                </button>
            </div>
        </div>
        <div class="box-block bg-white">
            <tabs :options="{useUrlFragment: false, defaultTabHash: 'assessors-all' }">
                <tab name="All" id="assessors-all" :class-name="'tab-content-table'">
                    <div class="pagination-block-bottom">
                        <b-table
                            class="rs-scroll rs-scroll--y"
                            responsive
                            style="overflow-x: auto"
                            hover
                            id="assessortable"
                            :items="assessors"
                            :filter-function="filterForTable"
                            :fields="computedFields"
                            :filter="filter"
                            @row-clicked="rowClicked"
                            :current-page="assessorsCurrentPage"
                            :per-page="assessorsPerPage"
                            :key="assessorsKey"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            @filtered="onAssessorsFiltered"
                        >
                        <template v-slot:cell(assessor_name)="row">
                            <b-form-input v-show="assessors_edit[row.index]" v-model="row.item.assessor_name"/>
                            <span class="td-warn" v-show="name_validator[row.index]">no valid name!</span>
                            {{ !assessors_edit[row.index] ? row.item.assessor_name : '' }}
                        </template>
                        <template v-slot:cell(assessor_email)="row">
                            <b-form-input v-show="assessors_edit[row.index]" v-model="row.item.assessor_email"/>
                            <span class="td-warn" v-show="email_validator[row.index]">no valid email!</span>
                            <span v-show="row.index==invalidRowIndex">*</span>
                            {{ !assessors_edit[row.index] ? row.item.assessor_email : '' }}
                        </template>
                        <template v-slot:cell(assessor_mobile_phone)="row">
                            <b-form-input v-show="assessors_edit[row.index]" v-model="row.item.assessor_mobile_phone"/>
                            <span class="td-warn" v-show="mobile_validator[row.index]">no valid mobile!</span>
                            {{ !assessors_edit[row.index] ? row.item.assessor_mobile_phone : '' }}
                        </template>
                        <template v-slot:cell(assessor_work_phone)="row">
                            <b-form-input v-show="assessors_edit[row.index]" v-model="row.item.assessor_work_phone"/>
                            {{ !assessors_edit[row.index] ? row.item.assessor_work_phone : '' }}
                        </template>
                        <template v-slot:cell(insurers)="row">
                            <div v-if="!assessors_edit[row.index] && Array.isArray(row.item.insurers)">
                              <span v-for="insurer in row.item.insurers">
                                    {{ insurer.insurer_name }}
                                <br/>
                              </span>
                            </div>
                            <div  v-else>
                            <multiselect
                                    v-model="row.item.insurers"
                                    :options="insurers"
                                    :option-height="29"
                                    :max-height="203"
                                    :close-on-select="false"
                                    :show-labels="false"
                                    track-by="insurer_id"
                                    label="insurer_name"
                                    :tabindex="2"
                                    :multiple="true"
                             >
                                <template slot="singleLabel" slot-scope="{ option }">
                                    {{ option.insurer_name }}
                                </template>
                                </multiselect>
                            </div>
                        </template>
                        <template v-slot:cell(type)="row">
                            <div style="margin-bottom: 10px">
                                <div class="d-flex">
                                    <label class="form-check-inline radio assessor-checkbox">
                                        <input :disabled="!assessors_edit[row.index]" v-model="row.item.type" class="form-check-input" type="radio" :name="'assessor_type' + row.item.id" :id="'internal' + row.item.id" value="Internal">
                                        <span class="icon" style="margin-left: 9px; margin-right: 27px; margin-bottom: 5px;"><i class='bx bx-check'></i></span><span class="text">Internal</span>
                                    </label>
                                    <label class="form-check-inline radio assessor-checkbox">
                                        <input :disabled="!assessors_edit[row.index]"  v-model="row.item.type" class="form-check-input" type="radio" :name="'assessor_type' + row.item.id" :id="'external' + row.item.id" value="External">
                                        <span class="icon" style="margin-left: 10px; margin-bottom: 5px;"><i class='bx bx-check'></i></span><span class="text" style="margin-right: 11px;">External</span>
                                    </label>
                                </div>
                            </div>
                        </template>
                        <template v-slot:cell(edit_assessor)="row">
                            <div class="d-flex">
                                <b-button :class="{btn_edit:!assessors_edit[row.index],btn_save:assessors_edit[row.index]}"
                                          @click="editAssessorRow(row.item,row.index)">
                                </b-button>
                                <b-button class="btn_trush" @click="deleteAssessor(row.item.id)"></b-button>
                            </div>
                        </template>
                        </b-table>
                    </div>
                    <block-pagination
                        :role="'assessors'"
                        :arrayOfSomeone="assessors"
                        :arrayOfSomeoneFiltered="assessorsFiltered2"
                        :currentPage="assessorsCurrentPage"
                        @changedCurrentPage="changedCurrentPage"
                        :perPage="assessorsPerPage"
                        @changedPerPage="changedPerPage"
                        >
                    </block-pagination>

                </tab>
                <template slot="nav-item-right">
                    <div class="tabs-nav-right-search right">
                        <b-form-input v-model="filter" type="text" class="form-control search-input"
                                      placeholder="Search or Filter results"
                                      debounce="100"></b-form-input>
                    </div>
                    <div class="tabs-nav-right-btn">
                        <button v-if="!isCustomerUser && isStatusActive" @click="addNewAssessorRow" class="btn add-button-table"><i
                                class="ti-plus"></i>New Assessor
                        </button>
                    </div>

                </template>
            </tabs>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import Axios from "axios";
    import {email} from "vuelidate/lib/validators";
    import Multiselect from 'vue-multiselect';
    import NumberFormatter from './utility/number-formatter';
    import BlockPagination from './utility/block-pagination';
    import {mapGetters} from "vuex";

    export default {
        name: "assessors",
        data: function () {
            return {
                assessors: [],
                newAssessors: [],
                insurers: [],
                assessors_edit: [],
                email_validator: [],
                name_validator: [],
                mobile_validator: [],
                isNewRow: [],
                filter: "",
                email_reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                number_reg: /^\d+$/,
                assessorsPerPage: 20,
                assessorsCurrentPage: 1,
                assessorsFiltered: [],
                invalidRowIndex: null,
                new_assessor_name: "",
                new_assessor_email: "",
                new_assessor_work_phone: "",
                new_assessor_mobile_phone: "",
                new_insurer_id: "",
                new_insurers: "",
                new_type: "",
                row_insure_id: "",
                assessorsKey: 1,
                selectedAssessor: null,
                sortDesc: false,
                sortBy: 'assessor_name',

                states: {
                    QLD: "Queensland",
                    NT: "Northern Territory",
                    NSW: "New South Wales",
                    VIC: "Victoria",
                    TAS: "Tasmania",
                    SA: "South Australia",
                    WA: "Western Australia"
                },
                columns: [
                    {
                        label: "Assessor Name",
                        data: "assessor_name",
                        className: "clickable"
                    },
                    {label: "Email", data: "assessor_email", className: "clickable"},
                    {
                        label: "Mobile Phone",
                        data: "assessor_mobile_phone",
                        className: "clickable"
                    },
                    {
                        label: "Work Phone",
                        data: "assessor_work_phone",
                        className: "clickable"
                    },
                    {label: "Insurer", data: "insurer_name", className: "clickable"}
                ]
            };
        },
        validations: {
            new_assessor_email: {
                email
            },
            selectedAssessor: {
                assessor_email: {
                    email
                }
            }
        },
        computed: {
            ...mapGetters({
                'isCustomerUser': 'isCustomerUser',
                isStatusActive: 'isStatusActive',
                getterBusinessName : 'getBusinessName',
              }
            ),
            computedFields() {
              let fields = [
                  {
                    label: "Assessor Name",
                    key: "assessor_name",
                    tdClass: 'clickable text-left font-weight-bold td-text align-top',
                    thClass: 'bg-navyblue text-left th-text',
                    sortable: true
                  },
                  {
                    label: "Email",
                    key: "assessor_email",
                    tdClass: 'text-left clickable font-weight-600 td-text align-top',
                    thClass: 'text-left th-text bg-navyblue',
                    sortable: true
                  },
                  {
                    label: "Mobile Phone",
                    key: "assessor_mobile_phone",
                    tdClass: 'text-left clickable font-weight-600 td-text align-top',
                    thClass: 'text-left th-text bg-navyblue',
                    sortable: true
                  },
                  {
                    label: "Work Phone",
                    key: "assessor_work_phone",
                    tdClass: 'text-left clickable font-weight-600 td-text align-top',
                    thClass: 'text-left th-text bg-navyblue',
                    sortable: true
                  },
                  {
                    label: "Insurers",
                    key: "insurers",
                    tdClass: 'text-left insurer-td clickable font-weight-600 td-text align-top',
                    thClass: 'text-left th-text bg-navyblue',
                    sortable: true
                  },
                  {
                    label: "Assessor Type",
                    key: "type",
                    tdClass: 'text-left clickable font-weight-600 td-text assessor-type-block align-top',
                    thClass: 'text-left th-text bg-navyblue assessor-type-block',
                    sortable: true
                  },
                ]
                if (this.isCustomerUser || !this.isStatusActive) {
                  return fields
                }
                fields.push({
                  label: "Edit",
                  key: "edit_assessor",
                  tdClass: 'text-left clickable font-weight-600 td-text align-top assessors-edit-btn',
                  thClass: 'text-left th-text bg-navyblue assessors-edit-btn',
                  sortable: true
                })
                return fields
            },
            assessorsFiltered2() {
                return this.assessorsFiltered;
            },
        },
        methods: {
          filterForTable(row, filter) {
              let formattedFilter = filter.toLowerCase();
              if (row.assessor_email && row.assessor_email.toLowerCase().includes(formattedFilter)) {
                return true;
              } else if (row.assessor_mobile_phone && row.assessor_mobile_phone.includes(formattedFilter)) {
                return true;
              } else if (row.assessor_name && row.assessor_name.toLowerCase().includes(formattedFilter)) {
                return true;
              } else if (row.assessor_work_phone && row.assessor_work_phone.includes(formattedFilter)) {
                return true;
              } else if (row.type && row.type.toLowerCase().includes(formattedFilter)) {
                return true;
              } else if (row.insurers && row.insurers.length > 0) {
                let bool = false;
                _.forEach(row.insurers, (i) => {
                  if (i.insurer_name.toLowerCase().includes(formattedFilter)) {
                    bool = true
                  }
                })
                if (bool) {
                  return true;
                }
              }
              return false;
            },
            changedCurrentPage(value){
                this.assessorsCurrentPage = value;
            },
            changedPerPage(value){
                this.assessorsPerPage = value;
            },

            onInsurerSelect: function (item, index) {
                this.editAssessorRow(item, index);
            },
            rowClicked: function (item, index, event) {
                if (this.assessors_edit[index]) {
                    return;
                }
                this.editAssessorRow(item, index);
            },
            setDataForAssessors: function () {
                this.assessors_edit = Array.from({length: this.assessors.length}).map(_ => false);
                this.email_validator = Array.from({length: this.assessors.length}).map(_ => false);
                this.name_validator = Array.from({length: this.assessors.length}).map(_ => false);
                this.mobile_validator = Array.from({length: this.assessors.length}).map(_ => false);
            },
            loadInsurers: function () {
                Axios.get("/fe/insurer")
                    .then(response => {
                        this.insurers = _.sortBy(response.data.data, [function(insurer) {
                          return insurer.insurer_name.trim().toLowerCase();
                        }]);
                        NProgress.done();
                    })
                    .catch(error => {
                        console.log(error);
                        NProgress.done();
                    });
            },
            loadAssessors: function (isSetData = true) {
                this.isNewRow = [];
                NProgress.start();
                Axios.get("/fe/assessor")
                    .then(response => {
                        this.assessors = _.map(response.data.data, (item, index) => {
                          let insurersSort = _.sortBy(item.insurers, [function(insurer) {
                            return insurer.insurer_name.trim().toLowerCase();
                          }]);
                          item.insurers = insurersSort;
                          return item;
                        });
                        this.assessorsFiltered = _.map(response.data.data, (item, index) => {
                          let insurersSort = _.sortBy(item.insurers, [function(insurer) {
                            return insurer.insurer_name.trim().toLowerCase();
                          }]);
                          item.insurers = insurersSort;
                          return item;
                        });
                        if (isSetData) this.setDataForAssessors();
                        this.loadInsurers();
                    })
                    .catch(error => {
                        console.log(error);
                        NProgress.done();
                    });
            },
            createAssessors: function () {
                if (this.$v.new_assessor_email.$anyError) {
                    toastr.error(
                        "Your changes could not be saved, please check the form fields again"
                    );
                    return;
                }
                if (
                    this.new_assessor_name != "" &&
                    this.new_assessor_email != "" &&
                    this.new_assessor_work_phone != "" &&
                    this.new_assessor_mobile_phone != ""
                ) {
                    this.addNewAssessor();
                }

                if (this.newAssessors.length == 0) {
                    return false;
                }

                NProgress.start();
                Axios.post(
                    "/fe/assessor",
                    JSON.stringify({assessors: this.newAssessors})
                )
                    .then(response => {
                        this.loadAssessors();
                        toastr.success("Assessor/s created");
                        NProgress.done();
                    })
                    .catch(error => {
                        console.log(error);
                        NProgress.done();
                        return false;
                    });

                return true;
            },
            deleteAssessor: function (id) {
                if (_.isEmpty(id)) {
                    let assessors = this.assessors;
                    assessors.shift();
                    this.assessors = assessors;
                    this.setDataForAssessors();
                    return;
                }
                if (confirm('Are you sure?')) {
                    NProgress.start();
                    Axios.post(
                      `/fe/assessor/${id}/delete`
                    )
                      .then(response => {
                        this.loadAssessors();
                        toastr.success("Assessor deleted");
                        NProgress.done();
                      })
                      .catch(error => {
                        console.log(error);
                        NProgress.done();
                        return false;
                      });
                }

                return true;
            },
            updateAssessor: function () {
                if (this.$v.$anyError) {
                    toastr.error("Please check error in the fields");
                    return;
                }
                if (!(this.selectedAssessor.id > 0)) {
                    return;
                }
                NProgress.start();
                this.selectedAssessor.insurer_id = this.selectedAssessor.id;
                Axios.post(
                    `/fe/assessor/${this.selectedAssessor.id}`,
                    this.selectedAssessor
                )
                    .then(response => {
                        this.loadAssessors();
                        toastr.success("Assessor info updated");
                        NProgress.done();
                    })
                    .catch(error => {
                        console.log(error);
                        NProgress.done();
                        return false;
                    });

                return true;
            },
            addNewAssessorRow: function () {
                if (!_.isEmpty(this.isNewRow)) {
                    return;
                }

                this.setDataForAssessors();

                const temp = {
                    DT_RowId: '',
                    assessor_name: '',
                    assessor_email: '',
                    assessor_work_phone: '',
                    assessor_mobile_phone: '',
                    insurers: [],
                    type: 'Internal',
                };

                this.assessors = [
                    temp,
                    ...this.assessors
                ];
                this.isNewRow.push(true);
                this.assessors_edit = [true, ...this.assessors_edit];
            },
            addNewAssessor: function () {
                if (this.$v.$anyError) {
                    toastr.error("Please check error in the fields");
                    return;
                }
                if (
                    this.new_assessor_name == "" ||
                    this.new_assessor_email == "" ||
                    this.new_insurer_id == ""
                ) {
                    return;
                }
                this.newAssessors.push({
                    assessor_name: this.new_assessor_name,
                    assessor_email: this.new_assessor_email,
                    assessor_mobile_phone: this.new_assessor_mobile_phone,
                    assessor_work_phone: this.new_assessor_work_phone,
                    insurers: this.new_insurers,
                    type: this.new_type,
                });

                this.new_assessor_name = "";
                this.new_assessor_email = "";
                this.new_assessor_mobile_phone = "";
                this.new_assessor_work_phone = "";
                this.new_insurer_id = "";
            },
            onAssessorsFiltered: function (fi) {
                console.log("fi", fi);
                this.assessorsFiltered = fi;
                this.assessorsCurrentPage = 1;
            },
            editAssessorRow: function (item, index) {
                if (this.isCustomerUser || !this.isStatusActive) {
                  return;
                }
                this.assessorsKey++;

                if (!_.isEmpty(item.DT_RowId)) {
                    this.assessors_edit = _.map(this.assessors_edit, (item, indexEl) => {
                        if (indexEl !== index) {
                            item = false;
                        }
                        return item;
                    });
                }

                if (!_.isEmpty(this.isNewRow) && !_.isEmpty(item.DT_RowId)) {
                    this.isNewRow = [];
                    let assessors = this.assessors;
                    assessors.shift();
                    this.assessors = assessors;
                }

                if (!this.email_reg.test(item.assessor_email)) {
                    this.email_validator[index] = true;
                } else {
                    this.email_validator[index] = false;
                }
                if (item.assessor_name === '') {
                    this.name_validator[index] = true;
                } else {
                    this.name_validator[index] = false;
                }
                if (!this.email_reg.test(item.assessor_email) || item.assessor_name === '') {
                    this.assessors_edit[index] = !this.assessors_edit[index];
                    return;
                }
                this.assessors_edit[index] = !this.assessors_edit[index];
                if (!this.assessors_edit[index]) {
                    let insurers = [];
                    if (Array.isArray(item.insurers)) {
                      _.forEach(item.insurers, function(insurer) {
                        insurers.push({
                            ...insurer,
                            id: insurer.insurer_id,
                          }
                        )
                      })
                      insurers = _.sortBy(insurers, [function(insurer) {
                        return insurer.insurer_name.trim().toLowerCase();
                      }]);
                    } else {
                      insurers.push({
                        ...item.insurers,
                        id: item.insurers.insurer_id,
                      })
                    }
                    if (!this.isNewRow[index]) {
                        const newItem = {
                            assessor_email: item.assessor_email,
                            assessor_mobile_phone: item.assessor_mobile_phone,
                            assessor_name: item.assessor_name,
                            assessor_work_phone: item.assessor_work_phone,
                            id: item.id,
                            insurers: insurers,
                            type: item.type,
                        };
                        console.log('newItem', newItem);
                        NProgress.start();
                        Axios.post(
                            `/fe/assessor/${item.id}`,
                            newItem
                        )
                            .then(response => {
                                this.loadAssessors();
                                toastr.success("Assessor info updated");
                                NProgress.done();
                            })
                            .catch(error => {
                                console.log(error);
                                NProgress.done();
                                return false;
                            });
                    } else {
                        console.log('abd');
                        this.newAssessors.push({
                            assessor_name: item.assessor_name,
                            assessor_email: item.assessor_email,
                            assessor_mobile_phone: item.assessor_mobile_phone,
                            assessor_work_phone: item.assessor_work_phone,
                            insurers: insurers,
                            insurer_id: '1',
                            type: item.type,
                        });
                        NProgress.start();
                        Axios.post(
                            `/fe/assessor`,
                            {assessors: this.newAssessors})
                            .then(response => {
                                this.loadAssessors();
                                toastr.success('Assessor/s created');
                                NProgress.done();
                            })
                            .catch(error => {
                                console.log(error);
                                NProgress.done();
                                return false;
                            });
                    }
                }
            }
        },
        mounted: function () {
            this.loadAssessors();
        },
        components: {
            // DataTables
            Multiselect,
            NumberFormatter,
            BlockPagination,
        }
    };
</script>

<style scoped>
    .nav-link.active {
        width: 60px;
        display: inline-block;
        line-height: 2.7;
        text-align: center;
    }

    .btn_edit {
        background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTlweCIgaGVpZ2h0PSIxOXB4IiB2aWV3Qm94PSIwIDAgMTkgMTkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA2MiAoMTAxMDEwKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT5BQkU0Q0UxRi0yMDAyLTQ2QTEtQTVBMS0yRTUwMDg0MDQ5MTE8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGcgaWQ9IlVJLURlc2lnbiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkRhc2hib2FyZC1SZWRlc2lnbi0oVmlldy1Bc3Nlc29ycykiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzc1LjAwMDAwMCwgLTEwMDYuMDAwMDAwKSIgZmlsbD0iIzFCMUUzOCIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGcgaWQ9IlJvdy0wMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjY1LjAwMDAwMCwgMTAwNS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJwZW5jaWwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExMTAuMDAwMDAwLCAxLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMi4yMzgsNS40NzIgTDMuMiwxNC41MSBMMi42MDksMTYuNTI2IEw0LjU4NCwxNS45NTUgTDEzLjY1Miw2Ljg4NyBMMTIuMjM4LDUuNDcyIFogTTEzLjc4LDMuOTMgTDE1LjE5NCw1LjM0NCBMMTYuNTEyLDQuMDI2IEMxNi43MDcxOTEsMy44MzA3NTAwNyAxNi43MDcxOTEsMy41MTQyNDk5MyAxNi41MTIsMy4zMTkgTDE1LjgwNCwyLjYxMiBDMTUuNjA4NzUwMSwyLjQxNjgwOTAzIDE1LjI5MjI0OTksMi40MTY4MDkwMyAxNS4wOTcsMi42MTIgTDEzLjc4MSwzLjkzIEwxMy43OCwzLjkzIFogTTE3LjIxOSwxLjE5OCBMMTcuOTI2LDEuOTA1IEMxOC45MDE5NTQ4LDIuODgxMjQ5NjMgMTguOTAxOTU0OCw0LjQ2Mzc1MDM3IDE3LjkyNiw1LjQ0IEw1LjYzNCwxNy43MzMgTDEuNDE0LDE4Ljk1MyBDMS4wNjM2NjE3LDE5LjA1NDAxMiAwLjY4NjExMjg5NCwxOC45NTYzNDA0IDAuNDI4NzExMjksMTguNjk4MTA2NSBDMC4xNzEzMDk2ODYsMTguNDM5ODcyNSAwLjA3NDg1NzQ1MiwxOC4wNjIwMTA0IDAuMTc3LDE3LjcxMiBMMS40MjUsMTMuNDU3IEwxMy42ODUsMS4xOTcgQzE0LjY2MTI0OTYsMC4yMjEwNDUxNTQgMTYuMjQzNzUwNCwwLjIyMTA0NTE1NCAxNy4yMiwxLjE5NyBMMTcuMjE5LDEuMTk4IFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=') no-repeat top left;
        border: none;
        height: 20px;
    }

    .btn_save {
        background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxnPg0KCQk8cGF0aCBkPSJNNTA2LjUxMywxMjQuMTJMMzg3Ljg3OSw1LjQ4NmMtMC4wMDEtMC4wMDEtMC4wMDMtMC4wMDMtMC4wMDUtMC4wMDRDMzg0LjQ2NywyLjA3NiwzNzkuNjk3LDAsMzc0LjYzNCwwDQoJCQljLTE1LjAxOCwwLTM0MS42LDAtMzU1LjkwMiwwQzguMzg3LDAsMCw4LjM4NywwLDE4LjczMnY0NzQuNTM3QzAsNTAzLjYxMyw4LjM4Nyw1MTIsMTguNzMyLDUxMmMyMi41NjMsMCw0NTIuMzUzLDAsNDc0LjUzNywwDQoJCQljMTAuMzQ1LDAsMTguNzMyLTguMzg3LDE4LjczMi0xOC43MzJWMTM3LjM2NkM1MTIsMTMyLjM5OCw1MTAuMDI3LDEyNy42MzQsNTA2LjUxMywxMjQuMTJ6IE0xNTYuMDk4LDM3LjQ2M2gxOTkuODA1djExMC44MjMNCgkJCUgxNTYuMDk4VjM3LjQ2M3ogTTQwMC40NSw0NzQuNTM3aC0yODguOVYzMTYuOTM1aDI4OC45VjQ3NC41Mzd6IE00NzQuNTM3LDQ3NC41MzdoLTM2LjYyM1YyOTguMjA0DQoJCQljMC0xMC4zNDUtOC4zODctMTguNzMyLTE4LjczMi0xOC43MzJIOTIuODE4Yy0xMC4zNDUsMC0xOC43MzIsOC4zODctMTguNzMyLDE4LjczMnYxNzYuMzMzSDM3LjQ2M1YzNy40NjNoODEuMTcxdjEyOS41NTUNCgkJCWMwLDEwLjM0NSw4LjM4NywxOC43MzIsMTguNzMyLDE4LjczMmgyMzcuMjY4YzEwLjM0NSwwLDE4LjczMi04LjM4NywxOC43MzItMTguNzMyVjYzLjk1NGw4MS4xNzEsODEuMTcxVjQ3NC41Mzd6Ii8+DQoJPC9nPg0KPC9nPg0KPGc+DQoJPGc+DQoJCTxwYXRoIGQ9Ik0zMDkuNTE0LDU1LjAxNWMtMTAuMzQ1LDAtMTguNzMyLDguMzg3LTE4LjczMiwxOC43MzJ2MzguMjU2YzAsMTAuMzQ2LDguMzg2LDE4LjczMiwxOC43MzIsMTguNzMyDQoJCQljMTAuMzQ1LDAsMTguNzMyLTguMzg3LDE4LjczMi0xOC43MzJWNzMuNzQ3QzMyOC4yNDYsNjMuNDAyLDMxOS44NTksNTUuMDE1LDMwOS41MTQsNTUuMDE1eiIvPg0KCTwvZz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjwvc3ZnPg0K') no-repeat center left;
        border: none;
        height: 20px;
    }

    .btn-trush {
        background: url('data:image/svg+xml;base64,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') no-repeat center left;
        border: none;
        height: 20px;
    }

    .nav-tabs {
        padding-bottom: 1px;
    }

    .ti-plus {
        margin-right: 15px;
        font-size: 15px;
    }

    .add-assessor-btn {
        font-weight: bold;
        height: 38px;
        width: 135px;
        border-radius: 3px;
        background-color: #5E79FF;
        border: none;
        color: white;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1.7;
    }

    .add-assessor-btn:hover {
        cursor: pointer;
    }

    .form-control.pull-right {
        height: 38px;
        margin-right: 20px;
    }

    .tab-content {
        padding-top: 10px;
        background: #e3e4e7;
    }

    .V3 label.radio > input[type="radio"]:checked:disabled + span.icon i {
        color: white;
    }

    .V3 label.radio > input[type="radio"]:checked + span.icon {
        background-color: #5E79FF;
    }

    .V3 label.radio {
        width: 80px;
    }

    @media screen and (max-width: 768px) {
        .header-display-name {
            display: none;
        }
    }
</style>
